import _ from "lodash";
import { TableAggregateHealthRow, Td } from "../../SetiTable.styled";
import React from "react";
import { AggregateTd, CountTd, FilteredAggregateTd } from "../ReportElements";
import trackingVersionMapping from "../../../constants/TrackingVersionMapping";

export function AggregateHealthRow({
  data,
  isPreHawkeye,
  canCreateIncident,
  groupsToShow,
  infoColumnCount,
  showPitchesAsCount = false,
  showBipAsCount = false,
  showSwingsAsCount = false,
}) {
  const trackingPerGame =
    data?.records?.map((info) => {
      return info["tracking"];
    }) || [];

  const gameInfoPerGame =
    data?.records?.map((info) => {
      return info["game"];
    }) || [];

  return (
    <TableAggregateHealthRow>
      <Td
        textAlignment="center"
        colSpan={infoColumnCount || (canCreateIncident ? 5 : 4)}
      >
        Overall Health
      </Td>
      <AggregateDataColumns
        gameInfoPerGame={gameInfoPerGame}
        trackingPerGame={trackingPerGame}
        isPreHawkeye={isPreHawkeye}
        groupsToShow={groupsToShow}
        showPitchesAsCount={showPitchesAsCount}
        showBipAsCount={showBipAsCount}
        showSwingsAsCount={showSwingsAsCount}
      />
    </TableAggregateHealthRow>
  );
}

function AggregateDataColumns({
  gameInfoPerGame,
  trackingPerGame,
  isPreHawkeye,
  groupsToShow,
  showPitchesAsCount = false,
  showBipAsCount = false,
  showSwingsAsCount = false,
}) {
  const gameAndTrackingArray = gameInfoPerGame.map((gameInfo, index) => ({
    ...gameInfo,
    ...trackingPerGame[index],
  }));

  const gameAndTrackingArrayWithVideoAvailability = gameAndTrackingArray.map(
    (obj) => {
      const addingBiomechAndVideo = { ...obj };

      if (obj.coachingVideo) {
        obj.coachingVideo.forEach((video) => {
          addingBiomechAndVideo[`${_.camelCase(video)}AvailableVideo`] =
            obj.totalPlays;
        });
      }

      addingBiomechAndVideo["midhomeAvailableVideo"] = obj.totalPlays;

      if (
        obj.trackingVersion &&
        !trackingVersionMapping.onlyPitchToPlate.includes(
          obj.trackingVersion?.id,
        )
      ) {
        addingBiomechAndVideo["expectedSpin"] = obj.pitchesWithSpin;
      }

      if (
        obj.trackingVersion &&
        trackingVersionMapping.biomechanicsAndPose.includes(
          obj.trackingVersion?.id,
        )
      ) {
        addingBiomechAndVideo[`expectedBiomechanics`] = obj.totalPlays;
        addingBiomechAndVideo[`expectedSwings`] = obj.totalSwings;
      }

      if (
        obj.trackingVersion &&
        !trackingVersionMapping.onlyFullPitch.includes(
          obj.trackingVersion?.id,
        ) &&
        !trackingVersionMapping.onlyPitchToPlate.includes(
          obj.trackingVersion?.id,
        )
      ) {
        addingBiomechAndVideo["expectedPlayer"] = obj.totalPlays;
      }

      if (
        (obj.trackingVersion &&
          trackingVersionMapping.pose.includes(obj.trackingVersion?.id)) ||
        trackingVersionMapping.biomechanicsAndPose.includes(
          obj.trackingVersion?.id,
        )
      ) {
        addingBiomechAndVideo["expectedPose"] = obj.totalPlays;
      }

      return addingBiomechAndVideo;
    },
  );

  const filteredGameAndTrackingObj =
    gameAndTrackingArrayWithVideoAvailability.map((obj) => ({
      pitches: obj.pitches || 0,
      pitchesOpticallyTracked: obj.pitchesOpticallyTracked || 0,
      pitchesWithSpin: obj.pitchesWithSpin || 0,
      reducedSpinConfidence: obj.reducedSpinConfidence || 0,
      broadcastVideo: obj.broadcastVideo || 0,
      alternateBroadcastVideo: obj.alternateBroadcastVideo || 0,
      chHighSideviewVideo: obj.chHighSideviewVideo || 0,
      highHomeVideo: obj.highHomeVideo || 0,
      midHomeVideo: obj.midHomeVideo || 0,
      broadcastReview: obj.broadcastReview || 0,
      alternateBroadcastReview: obj.alternateBroadcastReview || 0,
      centerfieldVideo: obj.centerfieldVideo || 0,
      pitchcastVideo: obj.pitchcastVideo || 0,
      firstBasePitcherSideViewVideo: obj.firstBasePitcherSideViewVideo || 0,
      thirdBasePitcherSideViewVideo: obj.thirdBasePitcherSideViewVideo || 0,
      firstBaseBatterSideViewVideo: obj.firstBaseBatterSideViewVideo || 0,
      thirdBaseBatterSideViewVideo: obj.thirdBaseBatterSideViewVideo || 0,
      broadcastAvailableVideo: obj.broadcastAvailableVideo || 0,
      alternateBroadcastAvailableVideo:
        obj.alternateBroadcastAvailableVideo || 0,
      pitchcastAvailableVideo: obj.pitchcastAvailableVideo || 0,
      centerfieldAvailableVideo: obj.centerfieldAvailableVideo || 0,
      chhighSideviewAvailableVideo: obj.chHighSideviewAvailableVideo || 0,
      highhomeAvailableVideo: obj.highHomeAvailableVideo || 0,
      midhomeAvailableVideo: obj.midhomeAvailableVideo || 0,
      firstBaseBatterSideviewAvailableVideo:
        obj["1BBatterSideviewAvailableVideo"] || 0,
      firstBasePitcherSideviewAvailableVideo:
        obj["1BPitcherSideviewAvailableVideo"] || 0,
      thirdBaseBatterSideviewAvailableVideo:
        obj["3BBatterSideviewAvailableVideo"] || 0,
      thirdBasePitcherSideviewAvailableVideo:
        obj["3BPitcherSideviewAvailableVideo"] || 0,
      bip: obj.bip || 0,
      totalPlays: obj.totalPlays || 0,
      totalHits: obj.totalHits || 0,
      swingsTracked: obj.swingsTracked || 0,
      expectedSwings: obj.expectedSwings || 0,
      expectedBiomechanics: obj.expectedBiomechanics || 0,
      batterBiomechanicsAvailable: obj.batterBiomechanicsAvailable || 0,
      pitcherBiomechanicsAvailable: obj.pitcherBiomechanicsAvailable || 0,
      playerTrackingCompleteness: obj.playerTrackingCompleteness || 0,
      expectedSpin: obj.expectedSpin || 0,
      expectedPose: obj.expectedPose || 0,
      expectedPlayer: obj.expectedPlayer || 0,
      poseTrackingCompleteness: obj.poseTrackingCompleteness || 0,
      challenges: obj.challenges || 0,
    }));

  const firstObj = filteredGameAndTrackingObj[0] || {};
  let trackingAggr = _.transform(
    firstObj,
    (result, value, key) => {
      result[key] = 0;
    },
    {},
  );

  _.reduce(
    filteredGameAndTrackingObj,
    (trackingAggr, x) => {
      return _.forEach(
        trackingAggr,
        (value, key) => (trackingAggr[key] += x[key]),
      );
    },
    trackingAggr,
  );

  const {
    pitches = 0,
    pitchesOpticallyTracked = 0,
    pitchesWithSpin = 0,
    reducedSpinConfidence = 0,
    broadcastVideo = 0,
    alternateBroadcastVideo = 0,
    chHighSideviewVideo = 0,
    highHomeVideo = 0,
    midHomeVideo = 0,
    broadcastReview = 0,
    alternateBroadcastReview = 0,
    centerfieldVideo = 0,
    pitchcastVideo = 0,
    firstBasePitcherSideViewVideo = 0,
    thirdBasePitcherSideViewVideo = 0,
    firstBaseBatterSideViewVideo = 0,
    thirdBaseBatterSideViewVideo = 0,
    broadcastAvailableVideo = 0,
    alternateBroadcastAvailableVideo = 0,
    centerfieldAvailableVideo = 0,
    highhomeAvailableVideo = 0,
    midhomeAvailableVideo = 0,
    chhighSideviewAvailableVideo = 0,
    pitchcastAvailableVideo = 0,
    firstBaseBatterSideviewAvailableVideo = 0,
    firstBasePitcherSideviewAvailableVideo = 0,
    thirdBaseBatterSideviewAvailableVideo = 0,
    thirdBasePitcherSideviewAvailableVideo = 0,
    bip = 0,
    totalPlays = 0,
    totalHits = 0,
    swingsTracked = 0,
    batterBiomechanicsAvailable = 0,
    pitcherBiomechanicsAvailable = 0,
    playerTrackingCompleteness = 0,
    poseTrackingCompleteness = 0,
    expectedSpin = 0,
    expectedBiomechanics = 0,
    expectedSwings = 0,
    expectedPose = 0,
    expectedPlayer = 0,
    challenges = 0,
  } = trackingAggr;

  return (
    <>
      {groupsToShow.showPitches && (
        <>
          {showPitchesAsCount ? (
            <CountTd count={pitches} totalPlays={totalPlays} />
          ) : (
            <AggregateTd count={pitches} totalPitches={totalPlays} />
          )}
          <FilteredAggregateTd
            count={pitchesOpticallyTracked}
            totalPitches={pitches}
            filtered={!isPreHawkeye} //Column is only shown pre HawkEye
          />
          <AggregateTd count={pitchesWithSpin} totalPitches={expectedSpin} />
          <AggregateTd
            count={reducedSpinConfidence}
            totalPitches={pitches}
            ceil={true}
          />
        </>
      )}
      {groupsToShow.showVideo && (
        <>
          <AggregateTd
            count={broadcastVideo}
            totalPitches={broadcastAvailableVideo}
          />
          <AggregateTd
            count={alternateBroadcastVideo}
            totalPitches={alternateBroadcastAvailableVideo}
          />
          <AggregateTd
            count={pitchcastVideo}
            totalPitches={pitchcastAvailableVideo}
          />
          <AggregateTd
            count={centerfieldVideo}
            totalPitches={centerfieldAvailableVideo}
          />

          <AggregateTd
            count={isPreHawkeye ? chHighSideviewVideo : highHomeVideo}
            totalPitches={
              isPreHawkeye
                ? chhighSideviewAvailableVideo
                : highhomeAvailableVideo
            }
          />
          <AggregateTd
            count={firstBasePitcherSideViewVideo}
            totalPitches={firstBasePitcherSideviewAvailableVideo}
          />
          <AggregateTd
            count={thirdBasePitcherSideViewVideo}
            totalPitches={thirdBasePitcherSideviewAvailableVideo}
          />
          <AggregateTd
            count={firstBaseBatterSideViewVideo}
            totalPitches={firstBaseBatterSideviewAvailableVideo}
          />
          <AggregateTd
            count={thirdBaseBatterSideViewVideo}
            totalPitches={thirdBaseBatterSideviewAvailableVideo}
          />
          <AggregateTd
            count={midHomeVideo}
            totalPitches={midhomeAvailableVideo}
          />
          {groupsToShow.showReviewAngles && (
            <>
              <AggregateTd count={broadcastReview} totalPitches={challenges} />
              <AggregateTd
                count={alternateBroadcastReview}
                totalPitches={challenges}
              />
            </>
          )}
        </>
      )}
      {groupsToShow.showHitting && (
        <>
          {showBipAsCount ? (
            <CountTd count={bip} totalPlays={totalHits} />
          ) : (
            <AggregateTd count={bip} totalPitches={totalHits} />
          )}
          {showSwingsAsCount ? (
            <CountTd count={swingsTracked} totalPlays={expectedSwings} />
          ) : (
            <AggregateTd count={swingsTracked} totalPitches={expectedSwings} />
          )}
        </>
      )}
      {groupsToShow.showPlayers && (
        <>
          <AggregateTd
            count={batterBiomechanicsAvailable}
            totalPitches={expectedBiomechanics}
          />
          <AggregateTd
            count={pitcherBiomechanicsAvailable}
            totalPitches={expectedBiomechanics}
          />
          <AggregateTd
            count={playerTrackingCompleteness}
            totalPitches={expectedPlayer}
          />
          <AggregateTd
            count={poseTrackingCompleteness}
            totalPitches={expectedPose}
          />
        </>
      )}
    </>
  );
}
